import React, { useContext } from 'react'

import { Box, LinkBank, LinkDetail, PageWrapper } from '@vividseats/vivid-ui-kit'

import RegionContext from '@/context/region'
import RelatedArtistContext from '@/context/related-artists'
import type { Performer } from '@/types/app-types'

import styles from './styles.module.scss'

type Props = {
    category: 'Concerts' | 'Theater' | 'Sports'
}

const RelatedArtists: React.FC<Props> = ({ category }) => {
    const {
        state: { data: region },
    } = useContext(RegionContext)
    const { selectors: relatedArtistSelectors } = useContext(RelatedArtistContext)
    const [relatedArtists] = relatedArtistSelectors

    const links: LinkDetail[] = relatedArtists.map((performer: Performer) => {
        return {
            id: performer.id,
            name: performer.name,
            url: performer.webPath,
        }
    })

    if (links.length === 0) {
        return null
    }

    return (
        <PageWrapper className={styles.relatedArtists} withGutters withMobileGutters white>
            <Box marginBottom={7}>
                <LinkBank title={`${region?.name} ${category} Tickets`} links={links} titleTextAs="h6" />
            </Box>
        </PageWrapper>
    )
}

export default RelatedArtists
